import { ReactNode } from 'react';

import { Box, BoxProps } from '@mui/material';
import clsx from 'clsx';

import { tokens } from '../../../theme/generated/tokens';
import { classNamesFor } from '../../../utils/classNames';
import { TypographyOrNode } from '../../utils';

const classNamesFactory = classNamesFor('PageSectionHeader');

const classNames = {
  root: classNamesFactory.root(),
};

export type PageSectionHeaderProps = {
  /**
   * Title of the section, displayed at the start of the header
   */
  title?: ReactNode;
  /**
   * Content to be displayed at the end of the header
   */
  endContent?: ReactNode;
  className?: string;
  alignItems?: BoxProps['alignItems'];
  children?: ReactNode;
};

export const PageSectionHeader = ({
  title,
  endContent,
  className,
  alignItems = 'flex-start',
  children,
}: PageSectionHeaderProps) => {
  return (
    <Box
      className={clsx(classNames.root, className)}
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems,
        gap: '12px',
        justifyContent:
          title && endContent
            ? 'space-between'
            : endContent
            ? 'flex-end'
            : 'flex-start',
      }}
    >
      {title != null && (
        <Box
          data-testid="page-section-title"
          sx={{
            flex: 1,
            minWidth: 0,
            color: tokens.theme.fg.structural.primary,
          }}
        >
          <TypographyOrNode variant="h5">{title}</TypographyOrNode>
        </Box>
      )}
      {endContent != null && <Box sx={{ flexShrink: 0 }}>{endContent}</Box>}
      {children}
    </Box>
  );
};

PageSectionHeader.classNames = classNames;
